import { LegacyIIQApi } from '../legacy-iiq-api';
import { GetMediaByKeySignedUrlResponse } from '@harvestiq/iiq-common/media/get-media-by-key-and-action-endpoint';

export const downloadMedia =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (filename: string) =>
    api.get(`/media/${filename}/download`);

export const getMediaSignedUrl =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  ({ key }: { key: string }) =>
    api.get<GetMediaByKeySignedUrlResponse>(`/media/${key}/signedUrl`);
